import modules from "modules";
import { useAppSelector } from "./use-app-selector";
import { useCallback } from "react";
import { ActiveBranch } from "modules/branch/types";
import { useAppDispatch } from "./use-app-dispatch";
import { usePcwUserCart } from "./use-pcw-cart";
import { useLoginStatus } from "hooks/useLoginStatus";
import { useRouter } from "next/router";
import { navigationRoutes } from "common/constants/navigation-routes";

const { selectors: branchSelectors, actions: branchActions } = modules.branch;

export const useBranchSelection = () => {
  const { pathname } = useRouter();
  const dispatch = useAppDispatch();
  const { getUserCartItemStock } = usePcwUserCart();
  const { isUserLogin } = useLoginStatus();

  const branchOptions = useAppSelector(branchSelectors.selectUserBranchOptions);
  const selectedBranch = useAppSelector(branchSelectors.selectCurrentBranch);
  const defaultBranch = useAppSelector(branchSelectors.selectDefaultBranch);
  const selectedBranchId = useAppSelector(
    branchSelectors.selectCurrentBranchId
  );
  const branchOptionsLoading = useAppSelector(
    branchSelectors.selectBranchOptionsLoading
  );

  const doNotShowAgain = useAppSelector(branchSelectors.selectDoNotShowAgain);

  const lastFetchedBranchesAt = useAppSelector(
    branchSelectors.selectLastFetched
  );

  const setAsCurrentBranch = useCallback(
    (branch: ActiveBranch) => {
      dispatch(branchActions.setCurrentBranch(branch));
      //TODO: depracated
      if (isUserLogin && pathname !== navigationRoutes.userCart) {
        getUserCartItemStock(branch?.id);
      }
    },
    [dispatch, getUserCartItemStock, isUserLogin, pathname]
  );

  const setAsDefaultBranch = useCallback(
    (branch: ActiveBranch) => {
      dispatch(branchActions.setDefaultBranch(branch));
    },
    [dispatch]
  );

  const getActiveBranches = useCallback(() => {
    dispatch(branchActions.getActiveBranchesThunk());
  }, [dispatch]);

  const handleDoNotShowAgain = useCallback(() => {
    dispatch(branchActions.setDoNotShowAgain());
  }, [dispatch]);

  return {
    branchOptions,
    selectedBranch,
    defaultBranch,
    branchOptionsLoading,
    selectedBranchId,
    doNotShowAgain,
    lastFetchedBranchesAt,

    getActiveBranches,
    setAsDefaultBranch,
    setAsCurrentBranch,
    handleDoNotShowAgain,
  };
};
